var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import imagePlaceholder from './img/img_thumb_placeholder.png';
var ImageLoader = /** @class */ (function (_super) {
    __extends(ImageLoader, _super);
    function ImageLoader(props) {
        var _this = _super.call(this, props) || this;
        _this.imgRef = React.createRef();
        return _this;
    }
    ImageLoader.prototype.componentDidMount = function () {
        var _this = this;
        var previewImg = new Image();
        previewImg.src = this.props.src;
        previewImg.onload = function () {
            if (_this.imgRef.current) {
                _this.imgRef.current.src = _this.props.src;
            }
        };
    };
    ImageLoader.prototype.render = function () {
        return (React.createElement("img", { ref: this.imgRef, src: imagePlaceholder, title: this.props.title }));
    };
    return ImageLoader;
}(React.Component));
export default ImageLoader;
//# sourceMappingURL=index.js.map